export default __webpack_public_path__ + "static/0-c4c57534dfa39b7c7e53262fbf956d6a.png";